import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { DatabaseZap, Loader2 } from "lucide-react";

export const RefreshDataButton = () => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/lead-data/missing").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  const go = async () => {
    if (!window.confirm(`Look up ATTOM, homes for sale and AvaData for ${info.count} leads with missing data for $${info.total.toFixed(2)}? Only blank fields are filled in.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/payments/refresh-checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(apiError(e)); setBusy(false); }
  };
  if (!info) return null;
  return (
    <Button variant="outline" onClick={go} disabled={busy || !info.count} data-testid="refresh-data-btn"
      title={info.count ? "Fill blank property and contact fields" : "All leads are filled in"}>
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <DatabaseZap className="mr-2 h-4 w-4" />}
      Update data{info.count ? ` · ${info.count} leads · $${info.total.toFixed(2)}` : ""}
    </Button>
  );
};
